module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#ch01",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("1 PEANUT BUTTER")])], 1)]), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#ch02",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("2 LEMON AND LIME")])], 1)]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("3 CARAMEL")])], 1)]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17), _vm._v(" "), _vm._m(18), _vm._v(" "), _vm._m(19), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _vm._m(25), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("4 BOOZE")])], 1)]), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27), _vm._v(" "), _vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _vm._m(31), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("5 PUMPKIN")])], 1)]), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33), _vm._v(" "), _vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36), _vm._v(" "), _vm._m(37), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("6 MALTED MILK POWDER")])], 1)]), _vm._v(" "), _vm._m(39), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _vm._m(42), _vm._v(" "), _vm._m(43), _vm._v(" "), _vm._m(44), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("7 CINNAMON")])], 1)]), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("8 CHEESE")])], 1)]), _vm._v(" "), _vm._m(52), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _vm._m(59), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("9 CHOCOLATE")])], 1)]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62), _vm._v(" "), _vm._m(63), _vm._v(" "), _vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _vm._m(66), _vm._v(" "), _vm._m(67), _vm._v(" "), _vm._m(68), _vm._v(" "), _c('p', {
    staticClass: "tocchap"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('big', [_vm._v("10 BANANA")])], 1)]), _vm._v(" "), _vm._m(69), _vm._v(" "), _vm._m(70), _vm._v(" "), _vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _vm._m(73), _vm._v(" "), _vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _vm._m(76), _vm._v(" "), _vm._m(77), _vm._v(" "), _vm._m(78), _vm._v(" "), _vm._m(79), _vm._v(" "), _vm._m(80), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _vm._m(81)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm05_toc"
    }
  }), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/toc.jpg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm06_intro#ch00_fm06_intro"
    }
  }, [_vm._v("Introduction: A Tale of Two Kitchens")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch00_fm07_eve#ch00_fm07_eve"
    }
  }, [_vm._v("Everything You Need to Know to Get Baked")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Good Morning Sunshine Bars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Crunchy Peanut Butter Banana Bread")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Peanut Butter")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oopsy Daisy Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal Peanut Butter Chocolate Chip Scones")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Chocolate Whirligigs")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch01#lev07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bale Bars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime Angel Food Cake with Lime Glaze")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sunrise Key Lime Tarts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Lime Champagne Granita")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lime Tarragon Cookies with White Chocolate Lime Topping")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Shaker Pie")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch02#lev13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Pistachio Cornmeal Muffins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel: Variations on a Theme")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dulce de Leche")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Caramel Sauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet and Salty Caramel Sauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Antique Caramel Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel Coconut Cluster Bars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Crème Brûlée with Caramelized Brown Sugar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Alfajores")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Candy Bar Tart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch03#lev23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Turtle Thumbprint Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bourbon, Vanilla, and Chocolate Milk Shakes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lacy Panty Cakes with Whiskey Sauce")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Triple Rum Black Pepper Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Chocolate Whiskey Tart with Whiskey Whipped Cream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whiskey Peach Upside-Down Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch04#lev29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("S’more-Style Chocolate Whiskey Pudding with Whiskey Marshmallow Topping")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toasted Pumpkin Seed Brittle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Almond Cake with Almond Butter Frosting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Homemade Pumpkin Puree")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Chunk Pumpkin Bread Pudding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Cinnamon Rolls")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Cheesecake Bars")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch05#lev36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Harvest Dunking Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil Dogs with Malted Buttercream Filling")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malted Vanilla Milk Shakes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malted Milk Chocolate Pots de Crème")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Milk Chocolate Malt Semifreddo with Chocolate Syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Malted Madeleines")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch06#lev42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Vanilla Bean Malt Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Classic Carrot Cake with Cinnamon Cream Cheese Frosting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whole-Wheat Cinnamon Sugar Pretzels")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Spicy Brownies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brown Butter Snickerdoodles")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Chocolate Soufflés")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Holiday Spice Cake with Eggnog Buttercream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch07#lev49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cinnamon Spritz Sandwich Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange Almond Ricotta Cheesecake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheddar Corn Soufflé")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Poppy Seed Pound Cake with Brown Butter Glaze")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon and Black Pepper Quiche")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Pecorino Pepper Icebox Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Cheesecake Muffins")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese Chocolate Snacking Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch08#lev57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesy Focaccia with Caramelized Onions and Sautéed Spinach")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Mayonnaise Cupcakes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mile-High Chocolate Cake with Vanilla Buttercream")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Candy Bar Cookies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Chip Orange Panettone")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Chocolate Mint Cookies with Chocolate Chunks")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tunnel of Hazelnut Fudge Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brooksters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Simple Chocolate Syrup")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch09#lev66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Velvet Walnut Fudge with Olive Oil and Fleur de Sel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bananas Cake")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Mousse Parfaits")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Whoopie Pies")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Banana Tart")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Caramel Pudding with Meringue Topping")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana in a Blanket")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch10#lev73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Honey Banana Poppy Seed Bread")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch11_ack#ch11_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_sou#ch12_sou",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch13_con#ch13_con",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conversion Charts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch14_inf#ch14_inf",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Infographic Source Notes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch15_index#ch15_index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/f0006-01.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8daf08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm05_toc.vue
// module id = 72
// module chunks = 0